import Api from './Api';
import Configuracao from '../util/Configuracao';

class DeclaracaoDeGastosApi extends Api {
  async consultarAnosBase () {
    try {
      const urlConsultarAnosBase = Configuracao.getConfiguracao().urlConsultarAnosBase;
      const response = await this.fetch(urlConsultarAnosBase);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDeclaracaoDeGastos (filter) {
    try {
      const urlConsultarDeclaracaoDeGastos = Configuracao.getConfiguracao().urlConsultarDeclaracaoDeGastos + filter.txtNumeroCarteira + '/' + filter.anoBase;
      const response = await this.fetch(urlConsultarDeclaracaoDeGastos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async gerarArquivo (filter) {
    try {
      const urlGerarArquivoDeclaracaoDeGastos = Configuracao.getConfiguracao().urlGerarArquivoDeclaracaoDeGastos + filter.anoBase;
      const response = await this.fetch(urlGerarArquivoDeclaracaoDeGastos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async gerarArquivoDmed (filter) {
    try {
      const urlGerarArquivoDeclaracaoDeGastosDmed = Configuracao.getConfiguracao().urlGerarArquivoDeclaracaoDeGastosDmed + filter.anoBase;
      const response = await this.fetch(urlGerarArquivoDeclaracaoDeGastosDmed);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default DeclaracaoDeGastosApi;
